/**
 * Troca "Apuração · Linha do tempo" (ORD-F-026; docs/TELA-COMENTARIOS.md §1): o mesmo `SegmentedControl` em cápsula das
 * abas de cargo (`role="group"`, `<button aria-pressed>`), sempre visível onde a tela existe, nos dois sentidos. A troca
 * é uma navegação com entrada no histórico (`setScreen`): cargo, lugar e momento ficam; Voltar e Esc voltam; `C`
 * alterna. Única parte da tela no JS crítico; a tela vem num pedaço à parte.
 */
import './ScreenToggle.css';
import { SegmentedControl, type SegmentedOption } from '../../components/SegmentedControl';
import { tScreen } from '../../copy/screen';
import { getOneKeyShortcuts, setScreen } from '../../state/actions';
import { useRoute } from '../../state/hooks';

type ScreenId = 'results' | 'comments';

export interface ScreenToggleProps {
  /** `header`: no cabeçalho, ao lado das abas de cargo; `bar`: barra do celular (2ª linha, acima dos cargos). */
  variant: 'header' | 'bar';
}

export function ScreenToggle({ variant }: ScreenToggleProps) {
  const route = useRoute();
  const key = getOneKeyShortcuts() ? 'C' : undefined;
  const options: SegmentedOption<ScreenId>[] = [
    { id: 'results', label: tScreen('timeline.toggle.results'), keyshortcut: key },
    { id: 'comments', label: tScreen('timeline.toggle.comments'), keyshortcut: key },
  ];
  return (
    <div class={`screen-toggle screen-toggle--${variant}`} data-testid="screen-toggle">
      <SegmentedControl<ScreenId>
        options={options}
        value={route.screen === 'comments' ? 'comments' : 'results'}
        onChange={(id) => setScreen(id === 'comments' ? 'comments' : null)}
        ariaLabel={tScreen('timeline.toggle.aria')}
        variant="capsule"
      />
    </div>
  );
}
